import { render, staticRenderFns } from "./TextMessageRow.vue?vue&type=template&id=b795f4ec&scoped=true&"
import script from "./TextMessageRow.vue?vue&type=script&lang=js&"
export * from "./TextMessageRow.vue?vue&type=script&lang=js&"
import style0 from "./TextMessageRow.vue?vue&type=style&index=0&id=b795f4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b795f4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b795f4ec')) {
      api.createRecord('b795f4ec', component.options)
    } else {
      api.reload('b795f4ec', component.options)
    }
    module.hot.accept("./TextMessageRow.vue?vue&type=template&id=b795f4ec&scoped=true&", function () {
      api.rerender('b795f4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rows/message-rows/TextMessageRow.vue"
export default component.exports